/** What the list shows – derived from `status` and `expiresAt` (expired is never stored). */
export enum OfferDisplayStatus {
  NOT_SENT = 'NOT_SENT',
  OPEN = 'OPEN',
  EXPIRED = 'EXPIRED',
  ACCEPTED = 'ACCEPTED',
  REVOKED = 'REVOKED'
}
